<div id="map" [style.height]="height"></div>
